import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User, UserRole } from '../../shared/models';
import { AppBaseHttpService } from '../../shared/services/app-base-http.service';
import { AppConfig } from './../../core/config/app.config';
import { AppConfigConstants } from './../../core/config/app.config.constants';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  constructor(private baseHttpService: AppBaseHttpService) { }

  createUser(user: User): Observable<User> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.USER_URL_SEGMENT]).concat('/create');
    return this.baseHttpService.post(url, user);
  }

  updateUser(user: User): Observable<void> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.USER_URL_SEGMENT]).concat('/update');
    return this.baseHttpService.post(url, user);
  }

  getUser(user: User): Observable<User[]> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.USER_URL_SEGMENT]).concat('/users');
    return this.baseHttpService.post(url, user);
  }

  getUserRole(userRole: UserRole): Observable<UserRole[]> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.USER_URL_SEGMENT]).concat('/user-roles');

    return this.baseHttpService.post(url, userRole);
  }

  getUserPermissions(userRole: UserRole): Observable<UserRole[]> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.USER_URL_SEGMENT]).concat('/user-roles');

    return this.baseHttpService.post(url, userRole);
  }


  getCheckUserEmailAvailability(user: User): Observable<boolean> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.USER_URL_SEGMENT]).concat('/check-email-availability');

    return this.baseHttpService.post(url, <User>{ emailAddress: user.emailAddress });
  }

  changePassword(user: User): Observable<boolean> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.USER_URL_SEGMENT]).concat('/changePassword');


    return this.baseHttpService.post(url, user);
  }

  loginUser(user: User): Observable<{ token: string, expiresAt: Date, user: User }> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.LOGIN_URL_SEGMENT]).concat(`/login-user`);

    return this.baseHttpService.post(url, user);
  }

  resetPassword(user: User): Observable<void> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.USER_URL_SEGMENT]).concat('/resetPassword');

    return this.baseHttpService.post(url, user);
  }

  forgotPassword(user: User): Observable<boolean> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.USER_URL_SEGMENT]).concat('/forgotPassword');

    return this.baseHttpService.post(url, user);

  }
}
